import { map } from "nanostores"
import { ProductDuration, PaymentProfile, Support } from "./support"
import { PromoValidation } from "./promo"

export type SubscriptionValue = "free" | ProductDuration

export interface Profile {
  newAccountCreated: boolean
  reloadRequired: boolean
  emailVerified: boolean
  authorized: boolean
  premium: boolean
  legacy12day: boolean
  source: string

  subscription: SubscriptionValue
  countryIso: string
  email: string
  password: string
  passwordConfirm: string

  paymentProfile: PaymentProfile
  premiumExpires: number | null
  paymentProblem: boolean
}

export interface PromoState {
  autoApply: boolean
  code: string
  showField: boolean
  validation: PromoValidation | null
}

export const profile = map<Profile>({
  newAccountCreated: false,
  reloadRequired: false,
  emailVerified: false,
  authorized: false,
  premium: false,
  legacy12day: false,
  source: "",

  subscription: "annually",
  countryIso: "",
  email: "",
  password: "",
  passwordConfirm: "",

  paymentProfile: null,
  premiumExpires: null,
  paymentProblem: false,
})

export const promo = map<PromoState>({
  autoApply: false,
  code: "",
  showField: false,
  validation: null,
})

export const support = map<Support | null>(null)
